import React from 'react'
import './index.css'

const NoDataMessage = () => {
  return <p className="no-data-notice">No data to display</p>
}

export default NoDataMessage



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/components/no-data-message/index.js